import React from 'react';
import logo from "../assets/g-logo.PNG";
import "../styles/Loading.scss";


const PageLoading = () => {

  return (
    <div className="loading-container">
      <img src={logo} alt="Logo" className="loading-logo" />
    </div>
  );
};

export default PageLoading

